import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onChange", "checked"]


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkdaySelector',
  props: {
    active: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
    active: number[]
};






const options = [
    {
        value: 1,
        label: 'Monday'
    },
    {
        value: 2,
        label: 'Tuesday'
    },
    {
        value: 3,
        label: 'Wednesday'
    },
    {
        value: 4,
        label: 'Thursday'
    },
    {
        value: 5,
        label: 'Friday'
    },
]

function toggle(day: number) {
    if (props.active.includes(day)) {
        emit('change', props.active.filter(activeDays => activeDays !== day))
    } else {
        emit('change', props.active.concat(day))
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
      return _createElementVNode("li", null, [
        _createElementVNode("label", null, [
          _createElementVNode("input", {
            onChange: () => toggle(option.value),
            type: "checkbox",
            checked: __props.active.includes(option.value)
          }, null, 40, _hoisted_1),
          _createElementVNode("span", null, _toDisplayString(option.label), 1)
        ])
      ])
    }), 64))
  ]))
}
}

})